export default function($) {
  const years = $('.js-projects-filters'),
        cards = $('.js-project-card');

  cards.each(function() {
    if ( $(this).data('year') < new Date().getFullYear() ) {
      $(this).removeClass('block')
      $(this).addClass('hidden')
    }
  })

  years.each(function(){
    if ( $(this).data('year') == 'all' ) {
      $(this).find('.js-project-filtered').removeClass('hidden')
      $(this).find('.js-project-filtered').addClass('block')
    }
  })

  years.on('click', function() {
    let yearSelected = $(this).data('year');

    if (yearSelected == "all") {
      cards.each( function() {
        let cardYear = $(this).data('year');

        if (cardYear >= new Date().getFullYear()) {
          $(this).removeClass('hidden')
          $(this).addClass('block')
        } else {
          $(this).removeClass('block')
          $(this).addClass('hidden')
        }
      })
    } else if (yearSelected == "old") {
      cards.each( function() {
        let cardYear = $(this).data('year');

        if (cardYear < new Date().getFullYear()) {
          $(this).removeClass('hidden')
          $(this).addClass('block')
        } else {
          $(this).removeClass('block')
          $(this).addClass('hidden')
        }
      })
    } else {
      cards.each( function() {
        let cardYear = $(this).data('year');

        if (cardYear === yearSelected) {
          $(this).removeClass('hidden')
          $(this).addClass('block')
        } else {
          $(this).removeClass('block')
          $(this).addClass('hidden')
        }
      })
    }


    $('.js-project-filtered').addClass('hidden')
    $(this).find('.js-project-filtered').removeClass('hidden')
    $(this).find('.js-project-filtered').addClass('block')
  })
}
